// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyDmSTpD3KGg40gWggOQibefc4bs3SDvMTg",
  authDomain: "cancionesia.firebaseapp.com",
  projectId: "cancionesia",
  storageBucket: "cancionesia.firebasestorage.app",
  messagingSenderId: "555979432649",
  appId: "1:555979432649:web:6dda62468eb2f74d246318",
  measurementId: "G-1PWL424JGZ"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);